import striptags from "striptags";

/**
 * Strips the HTML the SDK returns for descriptions (inline-styled `<span>`/`<br>` markup)
 * down to plain text paragraphs, so we can render them with our own theme typography.
 */
export function htmlToParagraphs(html: string): string[] {
  if (!html) {
    return [];
  }
  return striptags(html, "<br>")
    .split(/<\s*br\b[^>]*>/i)
    .map((paragraph) => paragraph.replace(/\s+/g, " ").trim())
    .filter(Boolean);
}
